(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get desired product collection (metafield)
    const collection = JSON.parse(section.querySelector(".collectionJSON").textContent);

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // get yagi discounted price data if applicable
    const yagiVariants = JSON.parse(section.querySelector(".yagiVariantJSON").textContent.replace(/[\n\s]/g, ''));

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/
    const thumbsSwiper = new Swiper(section.querySelector(".productVisualThumbs"), {
        slidesPerView: 5,
        spaceBetween: 14,
        autoHeight: true,
    });

    const productSwiper = new Swiper(section.querySelector(".productVisualSwiper"), {
        slidesPerView: 1.25,
        spaceBetween: 8,
        loop: false,
        autoHeight: true,
        thumbs: {
            swiper: thumbsSwiper,
        },
        breakpoints: {
            1000: {
                slidesPerView: 1,
                spaceBetween: 20,
            }
        }
    });

    // play video on slide play click
    section.querySelectorAll(".productVisualSwiperSlide").forEach(element => {
        element.addEventListener("click", function () {
            // get video
            const video = this.closest(".productVisualSwiperSlide").querySelector("video");

            if (!video) {
                return;
            }

            // remove play button if it hasn't already been removed
            this.querySelector(".productVisualSwiperSlidePlay")?.remove();

            // show controls
            video.controls = true;

            // play video
            video.play();
        });
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    });

    if (product.media.length > 1) {
        section.querySelector(".productVisualThumbs").classList.add("active");
    }


    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productSellingOptionPlanItemInput:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productSellingOptionPlan').value);
    }

    async function updateProduct() {
        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Not Available";
            return;
        }

        let selectedOptions = [];
        section.querySelectorAll(".productOptionsItemValuesLabelInput").forEach((element) => {
            if (element.checked && element.value !== "") {
                selectedOptions.push(element.value);
            }
        });
        product.variants.forEach(variant => {
            if (selectedOptions.length !== variant.options.length) {
                return;
            } else {
                // Create shallow copies to avoid modifying original arrays
                const sortedArr1 = [...selectedOptions].sort();
                const sortedArr2 = [...variant.options].sort();

                if (sortedArr1.every((value, index) => value === sortedArr2[index])) {
                    activeVariant = variant;
                }
            }
        });
        /**************
         Variant Image
         ***************/

        if (activeVariant.featured_image) {
            // change active slide
            productSwiper.slideTo(activeVariant.featured_image.position - 1);
        }

        /**************
         Quantity
         ***************/
        let qtyValue = section.querySelector(".productSellingOptionContentSelectorsQuantityCount");
        quantity = parseInt(qtyValue.textContent);

        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            let yagiPrice = yagiVariants.find(item => item.id === activeVariant.id)?.price;
            let tmpPrice = yagiPrice || activeVariant.price;

            section.querySelector(".productSellingOptionContentPriceReal").textContent = price(tmpPrice);
            section.querySelector(".productSellingOption").classList.add("active");
            section.querySelectorAll(".productATC").forEach(button => {
                button.disabled = false
            });
            section.querySelectorAll(".productSellingOptionContentSelectorsATCText").forEach(text => {
                text.textContent = "Add To Cart";
            });
            section.querySelector(".productUnavailable").classList.remove("active");
        } else {
            section.querySelector(".productSellingOption").classList.remove("active");
            section.querySelectorAll(".productATC").forEach(button => {
                button.disabled = true
            });
            section.querySelectorAll(".productSellingOptionContentSelectorsATCText").forEach(text => {
                text.textContent = "Out of Stock";
            });
            section.querySelector(".productUnavailable").classList.add("active");
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelectorAll(".productATC").forEach(atc => {
            atc.classList.add("loading");
        });

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productSellingOptionPlanItemInput:checked').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelectorAll(".productATC").forEach(atc => {
            atc.classList.remove("loading");
        });

        // open cart
        await openCart();
    }

    section.querySelectorAll('.productATC').forEach(atc => {
        atc.addEventListener("click", addToCart);
    });

    const webButtons = section.querySelector("#withWebButton") || false;
    if (webButtons) {
        section.querySelector("#withWebButton").addEventListener("change", () => {
            section.querySelector("#noWebButton").checked = false;
        });

        section.querySelector("#noWebButton").addEventListener("change", () => {
            section.querySelector("#withWebButton").checked = false;
        });
    }

    /***********************
     MODAL EVENT LISTENERS
     ***********************/
    const webModalExists = document.querySelector("#webbing_modal") || false;
    if (webModalExists) {
        section.querySelector("#webbing-modal-toggle").classList.add("active");
        section.querySelector("#webbing-modal-toggle").addEventListener("click", () => {
            document.querySelector("#webbing_modal").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    }

    const batterTypeModalExists = document.querySelector("#batter_type_modal") || false;
    if (batterTypeModalExists) {
        section.querySelector("#batter-type-toggle").classList.add("active");
        section.querySelector("#batter-type-toggle").addEventListener("click", () => {
            document.querySelector("#batter_type_modal").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    }

    const batterGloveSizeModalExists = document.querySelector("#batter-glove-size-modal") || false;
    if (batterGloveSizeModalExists) {
        section.querySelector("#batter-glove-size-toggle").classList.add("active");
        section.querySelector("#batter-glove-size-toggle").addEventListener("click", () => {
            document.querySelector("#batter-glove-size-modal").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    }
    const batterGloveGuaranteeExists = document.querySelector("#glove-guarantee-modal") || false;
    if (batterGloveGuaranteeExists) {
        section.querySelector("#guarantee-toggle").addEventListener("click", () => {
            document.querySelector("#glove-guarantee-modal").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    }
    const wholesaleModalExists = document.querySelector("#wholesale-modal") || false;
    if (wholesaleModalExists) {
        section.querySelector("#wholesale-toggle").addEventListener("click", () => {
            document.querySelector("#wholesale-modal").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    }
    const fieldingGloveSizeExists = document.querySelector("#fielding-glove-size-modal") || false;
    if (fieldingGloveSizeExists) {
        section.querySelector("#fielding-glove-size-toggle").classList.add("active");
        section.querySelector("#fielding-glove-size-toggle").addEventListener("click", () => {
            document.querySelector("#fielding-glove-size-modal").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    }
    const sleeveSizeExists = document.querySelector("#sleeve-size-modal") || false;
    if (sleeveSizeExists) {
        section.querySelector("#sleeve-size-toggle").classList.add("active");
        section.querySelector("#sleeve-size-toggle").addEventListener("click", () => {
            document.querySelector("#sleeve-size-modal").showModal();
            document.querySelector("body").classList.add("noScroll");
        });
    }

    /***********************
     QUANTITY PLUS MINUS LISTENERS
     ***********************/
    section.querySelector("#plus").addEventListener("click", () => {
        let currentCount = parseInt(section.querySelector(".productSellingOptionContentSelectorsQuantityCount").textContent);
        currentCount++;
        section.querySelector(".productSellingOptionContentSelectorsQuantityCount").textContent = currentCount.toString();
        updateProduct();
    });
    section.querySelector("#minus").addEventListener("click", () => {
        let currentCount = parseInt(section.querySelector(".productSellingOptionContentSelectorsQuantityCount").textContent);
        if (currentCount > 1) {
            currentCount--;
        }
        section.querySelector(".productSellingOptionContentSelectorsQuantityCount").textContent = currentCount.toString();
        updateProduct();
    })

    /********************
     Back in stock form
     *****************/

    section.querySelector(".productUnavailableForm")?.addEventListener("submit", async function (e) {
        e.preventDefault();

        // send to klaviyo
        await sendKlaviyoBackInStockRequest(section.querySelector(`.productUnavailableFormInput[name="email"]`).value, activeVariant.id);

        // success message
        this.innerHTML = `<h2 class="productUnavailableFormTitle">Thank You! We will notify you when available.</h2>`;
    })

}());